import _ from "underscore";
import Backbone from "backbone";
import Chaplin from "chaplin";
import RSVP from "rsvp";
import AssetsPageView from "views/myLibrary/AssetsPageView";
import PersistentModels from "services/PersistentModels";
import FileUploadHelper from "models/helper/FileUploadHelper";
import WorkspaceScope from "models/helper/WorkspaceScope";

const AssetsPageController = Chaplin.Controller.extend({
  initialize: function (options) {
    _.extend(this, Backbone.Events);
    if (options) {
      if (options.view) {
        this.view = options.view;
      }
      if (options.model) {
        this.model = options.model;
      }
    }
  },

  getModel: function () {
    return this.model;
  },

  getView: function () {
    return this.view;
  },

  showHomePopup: function () {
    PersistentModels.getInstance().getRouter().showHomePage();
  },

  _pickFileAndImport: function (accept, onFileSelected) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.style.display = "none";

    const cleanup = () => {
      if (input.parentNode) {
        input.parentNode.removeChild(input);
      }
    };

    input.addEventListener("change", async () => {
      try {
        const file = input.files && input.files[0] ? input.files[0] : null;
        if (!file) {
          cleanup();
          return;
        }
        await onFileSelected(file);
        window.dispatchEvent(new CustomEvent("trebble:workspace-library-updated"));
      } catch (error) {
        console.error("Failed to import asset:", error);
        window.alertErrorMessage(error || "Unable to import asset.");
      } finally {
        cleanup();
      }
    });

    document.body.appendChild(input);
    input.click();
  },

  _getAssetTypeForFile: function (file) {
    if (!file) {
      return null;
    }

    const normalizedMimeType = (file.type || "").toLowerCase();
    const normalizedName = (file.name || "").toLowerCase();

    if (normalizedName.endsWith(".svg")) {
      return "vector";
    }

    if (normalizedMimeType.startsWith("audio/")) {
      return "audio";
    }

    if (normalizedMimeType.startsWith("video/")) {
      return "video";
    }

    if (normalizedMimeType.startsWith("image/")) {
      return "image";
    }

    return null;
  },

  _importSelectedFile: function (file, workspaceId) {
    WorkspaceScope.requireResolved(workspaceId);
    const normalizedSelection = this._getAssetTypeForFile(file);

    if (normalizedSelection === "audio") {
      return FileUploadHelper.getInstance().showUploadDialogAndUploadFileToSoundLibrary(
        file,
        null,
        true,
        false,
        true,
        null,
        { workspaceId }
      );
    }

    if (normalizedSelection === "video") {
      return FileUploadHelper.getInstance().showUploadDialogAndUploadFileToSoundLibrary(
        file,
        null,
        true,
        true,
        true,
        null,
        { workspaceId }
      );
    }

    if (normalizedSelection === "image") {
      return FileUploadHelper.getInstance().showUploadDialogAndUploadImageAssetToLibrary(
        file,
        null,
        "image",
        true,
        null,
        { workspaceId }
      );
    }

    if (normalizedSelection === "vector") {
      return FileUploadHelper.getInstance().showUploadDialogAndUploadImageAssetToLibrary(
        file,
        null,
        "vector",
        true,
        null,
        { workspaceId }
      );
    }

    window.alertErrorMessage("Please select an audio, video, image, or SVG file.");
    return RSVP.Promise.resolve();
  },

  importAssets: function (options) {
    try {
      const workspaceId = WorkspaceScope.capture(options);
      return this._pickFileAndImport(
        "audio/*,video/*,image/*,.svg,.mp3,.wav,.m4a,.oga,.mp4,.mov,.webm,.mpeg,.ogg,.jpg,.jpeg,.png,.bmp,.webp",
        (file) => this._importSelectedFile(file, workspaceId)
      );
    } catch (error) {
      window.alertErrorMessage(error);
    }
  },

  buildModelAndRenderView: function () {
    return new RSVP.Promise(
      function (resolve, reject) {
        try {
          this.view = new AssetsPageView({});

          this.listenTo(this.view, "showHomePopup", this.showHomePopup);
          this.listenTo(this.view, "importAssets", this.importAssets);

          this.view.render();
          resolve();
        } catch (error) {
          reject(error);
        }
      }.bind(this)
    );
  },
});

export default AssetsPageController;
